// @generated by protoc-gen-connect-es v0.10.0 with parameter "target=ts"
// @generated from file src/protos/content_management/cms.teacher.questions.apis.proto (package geneo.cms.teacher.questions.upload.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { DeleteTeacherQuestionsRequest, DeleteTeacherQuestionsResponse, DownloadTeacherQuestionsTemplateRequest, DownloadTeacherQuestionsTemplateResponse, UpsertTeacherQuestionsRequest, UpsertTeacherQuestionsResponse } from "./cms.teacher.questions.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service geneo.cms.teacher.questions.upload.apis.TeacherUploadQuestionsAPIServiceV1
 */
export const TeacherUploadQuestionsAPIServiceV1 = {
  typeName: "geneo.cms.teacher.questions.upload.apis.TeacherUploadQuestionsAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.cms.teacher.questions.upload.apis.TeacherUploadQuestionsAPIServiceV1.downloadTeacherQuestionsTemplate
     */
    downloadTeacherQuestionsTemplate: {
      name: "downloadTeacherQuestionsTemplate",
      I: DownloadTeacherQuestionsTemplateRequest,
      O: DownloadTeacherQuestionsTemplateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.cms.teacher.questions.upload.apis.TeacherUploadQuestionsAPIServiceV1.upsertTeacherQuestions
     */
    upsertTeacherQuestions: {
      name: "upsertTeacherQuestions",
      I: UpsertTeacherQuestionsRequest,
      O: UpsertTeacherQuestionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc geneo.cms.teacher.questions.upload.apis.TeacherUploadQuestionsAPIServiceV1.deleteTeacherQuestions
     */
    deleteTeacherQuestions: {
      name: "deleteTeacherQuestions",
      I: DeleteTeacherQuestionsRequest,
      O: DeleteTeacherQuestionsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

